import {
  List as MUIList,
  ListItem as MuiListItem,
  ListItemAvatar as MuiListItemAvatar,
  ListItemAvatarProps,
  ListItemButton as MuiListItemButton,
  ListItemButtonProps,
  ListItemIcon as MuiListItemIcon,
  ListItemIconProps,
  ListItemProps,
  ListItemText as MuiListItemText,
  ListItemTextProps,
  ListProps,
  ListSubheader as MuiListSubheader,
  ListSubheaderProps,
} from '@mui/material';

export const List = (props: ListProps) => {
  return <MUIList {...props} />;
};

export const ListItem = (props: ListItemProps) => {
  return <MuiListItem {...props} />;
};

export const ListItemAvatar = (props: ListItemAvatarProps) => {
  return <MuiListItemAvatar {...props} />;
};

export const ListItemButton = (props: ListItemButtonProps) => {
  return <MuiListItemButton {...props} />;
};

export const ListItemIcon = (props: ListItemIconProps) => {
  return <MuiListItemIcon {...props} />;
};

export const ListItemText = (props: ListItemTextProps) => {
  return <MuiListItemText {...props} />;
};

export const ListSubheader = (props: ListSubheaderProps) => {
  return <MuiListSubheader {...props} />;
};
